import { Box, Typography, TextField, Button, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component"
import GCBackButton from "../../components/GreenCity/GCBackButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { colors } from "../../common/colors";
import { convertHeicToJpeg, getFileExtenction } from "../../common/files";
import { imageAcceptedExtension, validateImage } from "../../common/images";
import ButtonOutlinedCentered from "../../components/ButtonOutlined";
import { styles } from "../styles";
import { useAppDispatch } from "../../redux/store";
import { setGroupInfo } from "../../redux/Reducers/gcGroupReducer";
import { useSelector } from "react-redux";

const defaultImage = require("../../assets/images/placeholder.png");
function CreateGroupStep1(): ReactElement {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [groupName, setGroupName] = useState("");
  const [image, setImage] = useState<any>();
  const [imageFile, setImageFile] = useState<any>();
  const groupInfo = useSelector((state: any) => state.gcGroup);
  const [errors, setErrors] = useState({
    groupName: "",
    groupImage: "",
  });
  const [isPrivate, setIsPrivate] = useState("PUBLIC");

  useEffect(() => {
    window.scrollTo(0, 0);

    // eslint-disable-next-line
  }, []);

  const handleIsPrivateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //public private
    setIsPrivate((event.target as HTMLInputElement).value);
  };

  const fileInputRef = useRef<any>();

  const handleButtonClick = () => {
    fileInputRef?.current.click();
  };

  const handleFileChange = async (event: any) => {
    let file = event.target.files[0];
    if (!file) {
      console.error("ファイルを取得できませんでした。", event)
      return
    }

    const errMsg = validateImage(file)
    if (errMsg) {
      setErrors((prev) => ({ ...prev, groupImage: errMsg }));
      return
    }

    if (getFileExtenction(file) === "heic") {
      try {
        file = await convertHeicToJpeg(file);
      } catch (e: any) {
        console.error(e);
        return
      }
    }
    setImageFile(file);
    const imageUrl = URL.createObjectURL(file); // Generate URL from the file
    setImage(imageUrl); // Set the image URL
    setErrors((prev) => ({ ...prev, groupImage: "" }));
  };

  const handleNextStep = () => {
    if (groupName.trim().length < 3) {
      setErrors({
        ...errors,
        groupName: T("create_group_lack_of_required_item"),
      });
      return;
    }

    if (!image) {
      setErrors({
        ...errors,
        groupImage: T("create_group_lack_of_required_item"),
      });
      return;
    }

    dispatch(
      setGroupInfo({
        id: groupInfo?.id || "",
        edit: groupInfo?.id ? true : false,
        groupName,
        groupIsPublic: isPrivate === "PUBLIC",
        groupImage: imageFile || image,
      })
    );

    navigate("/steppii");
  };

  const handleBack = () => {
    dispatch(
      setGroupInfo({
        edit: false,
        groupIsPublic: groupInfo?.groupIsPublic === true || groupInfo?.groupIsPublic === "Public"
          ? "Public" : "Private"
      })
    )
    navigate(-1)
  }

  useEffect(() => {
    if (groupInfo) {
      setGroupName(groupInfo?.groupName);
      let isPublic;
      if (typeof groupInfo?.groupIsPublic === "string") {
        isPublic = groupInfo?.groupIsPublic.toUpperCase(); // Convert string to uppercase
      } else if (typeof groupInfo?.groupIsPublic === "boolean") {
        isPublic = groupInfo?.groupIsPublic === true ? "PUBLIC" : "PRIVATE"; // Convert boolean to YES/NO
      }
      setIsPrivate(isPublic);

      if (groupInfo?.groupImage instanceof File) {
        setImageFile(groupInfo.groupImage);
        setImage(URL.createObjectURL(groupInfo.groupImage));
      }
    }
  }, [groupInfo]);

  return (
    <div style={{ paddingTop: 100, height: "100vh" }}>
      <Box>
        <GCBackButton onClick={() => handleBack()} />
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <PeopleAltOutlinedIcon style={{ fontSize: 20 }} />
          <Typography style={{ fontSize: 14 }}>&nbsp; {T("create_group_title")}</Typography>
        </Box>
        <Box
          style={{
            backgroundColor: colors.farm_gray15,
            padding: 16,
          }}
        >
          <Typography
            style={{
              borderBottomColor: colors.farm_green150,
              borderBottomWidth: 2,
              borderBottomStyle: "solid",
              fontSize: 14,
            }}
          >
            {T("group_name")}{T("required")}
          </Typography>
          <TextField
            fullWidth
            hiddenLabel
            id="outlined-basic"
            error={errors.groupName != ""}
            helperText={errors.groupName ?? ""}
            variant="outlined"
            // disabled={groupInfo?.id}
            value={groupName}
            onChange={(e: any) => {
              setGroupName(e?.target?.value);
              if (e?.target?.value.length > 3) {
                setErrors({ ...errors, groupName: "" });
              }
            }}
            InputProps={{
              style: {
                height: 40, // Set your desired height here
                padding: "4px 8px", // Adjust padding to fit your design
                backgroundColor: colors.farm_white,
              },
            }}
            style={{ marginTop: 6 }} // Keep margin top if needed
          />

          <Box style={{ marginTop: 40 }}>
            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                fontSize: 14,
              }}
            >
              {T("create_group_icon")}{T("required")}
            </Typography>
            {errors.groupImage && <Typography sx={{ color: colors.farm_red600 }}>{errors.groupImage}</Typography>}
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: 10,
              }}
            >
              <img
                alt=""
                style={{
                  height: 100,
                  width: 100,
                  borderRadius: 50,
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderColor: colors.farm_green500,
                }}
                src={image || defaultImage}
              />
            </Box>
            <div>
              <ButtonOutlinedCentered
                title={T("create_group_select_image")}
                onClick={handleButtonClick}
                pLR={6}
                sx={{marginTop: "20px"}}
              />
              <input
                type="file"
                accept={imageAcceptedExtension}
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }} // Hide the file input
              />
            </div>

            <Typography
              style={{
                borderBottomColor: colors.farm_green150,
                borderBottomWidth: 2,
                borderBottomStyle: "solid",
                marginTop: 40,
              }}
            >
              &nbsp;{T("create_group_private_setting")}{T("required")}
            </Typography>
            <RadioGroup aria-labelledby="payment-radio-buttons-group-label" value={isPrivate} onChange={handleIsPrivateChange} name="radio-buttons-group">
              <FormControlLabel
                value="PUBLIC"
                disabled={groupInfo?.id ? true : false}
                control={<Radio sx={{ alignSelf: "flex-start" }} />} // Aligns the radio button to the top
                label={
                  <div>
                    <Typography variant="body1">{T("create_group_public")}</Typography>

                    <Typography variant="body2" color="textSecondary">
                      {T("create_group_public_description")}
                    </Typography>
                    <br />
                  </div>
                }
              />
              <FormControlLabel
                value="PRIVATE"
                disabled={groupInfo?.id ? true : false}
                control={<Radio sx={{ alignSelf: "flex-start" }} />} // Aligns the radio button to the top
                label={
                  <div>
                    <Typography variant="body1">{T("create_group_private")}</Typography>

                    <Typography variant="body2" color="textSecondary">
                      {T("create_group_private_description")}
                    </Typography>
                    <br />
                  </div>
                }
              />
            </RadioGroup>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={() => {
                  handleNextStep();
                }}
                style={{
                  ...styles.introSliderBtn,
                  marginTop: 40,
                  width: 220,
                }}
                size={"large"}
                variant="contained"
                endIcon={<ArrowForwardIosIcon />}
              >
                <span style={{ paddingRight: 30, paddingLeft: 40 }}>{T("next")}</span>
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default CreateGroupStep1;
